import React, { useState, useRef } from 'react';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import { Box, Typography, OutlinedInput, MenuItem } from '@material-ui/core';

import { getFormattedDateInput } from './MTSUtils';
import MTSStyle, { CustomInputMenu } from './MTSStyle';
import { DateRangeContext } from '../Preview.context';
import ShowCalender from 'components/Calendar/ShowCalendar';
import { initialState } from './MultiTimeSelectionWidget';

const MTSCustomRangeInput = (props) => {
	const {
		calendarAnchorEl,
		setCalendarAnchorEl,
		dateRange,
		isWeekRange,
		isDateRange,
		setRangeType,
		setDateRange,
		onOptionAdd,
		onOptionRemove,
		disabled,
		isFirstCustomRange = false
	} = props;
	const classes = MTSStyle();

	const [anchorEl, setAnchorEl] = useState(null);
	/**
	 * Calendar related states
	 */
	const [updateDateFor, setUpdateDateFor] = useState(null);
	const startDateRef = useRef(null);
	const endDateRef = useRef(null);

	const isMenuOpened = Boolean(anchorEl);
	const isCustomInputOpened = isWeekRange || isDateRange;

	const onClose = () => {
		setAnchorEl(null);
		setCalendarAnchorEl(null);
	};
	const onInputClick = (event) => {
		if (!disabled) {
			setAnchorEl(event.currentTarget);
		}
	};

	const onRangeTypeSelect = (type) => {
		onClose();
		setRangeType(type);
	};

	const onRemoveInputClick = (e) => {
		e.stopPropagation();
		onOptionRemove();
		setRangeType('');
		setDateRange(initialState);
		setCalendarAnchorEl(null);
	};

	/**
	 * Calendar methods
	 */
	const handleSetDateRange = (selection) => {
		const { start, end, week1, week2 } = selection;
		setDateRange({ start, end, week1, week2 });
		onOptionAdd();
		if (dateRange.start && selection.start.isBefore(dateRange.start)) {
			startDateRef.current.focus();
			setUpdateDateFor('START');
			return;
		}
		setUpdateDateFor('END');
		endDateRef.current?.focus();
	};

	const idNumber = isFirstCustomRange ? '0' : '1';

	return (
		<>
			<Box className={`${classes.MTSCustomRangeInputBox}${disabled ? '-disabled' : ''}`}>
				<Box className={classes.MTSInputLabelBox}>
					<Typography>
						Custom range {isDateRange ? '• By day' : ''}
						{isWeekRange ? '• By week' : ''}
					</Typography>
					{isCustomInputOpened ? (
						<RemoveIcon
							id={`mts-custom-remove-${idNumber}`}
							fontSize="small"
							onClick={onRemoveInputClick}
							className={classes.InputIcon}
						/>
					) : (
						<AddIcon
							id={`mts-custom-add-${idNumber}`}
							onClick={onInputClick}
							fontSize="small"
							className={classes.InputIcon}
						/>
					)}
				</Box>
				{isCustomInputOpened ? (
					<Box className={classes.MTSTimeRangeInputBox}>
						<OutlinedInput
							id="start-date"
							ref={startDateRef}
							autoComplete="off"
							className={classes.MTSTimeRangeInput}
							value={getFormattedDateInput(dateRange.start, dateRange.week1, isWeekRange)}
							onClick={(event) => setCalendarAnchorEl(event.currentTarget)}
							placeholder={isWeekRange ? 'Start week' : 'Start date'}
						/>
						<OutlinedInput
							id="end-date"
							ref={endDateRef}
							autoComplete="off"
							className={classes.MTSTimeRangeInput}
							value={getFormattedDateInput(dateRange.end, dateRange.week2, isWeekRange)}
							onClick={(event) => setCalendarAnchorEl(event.currentTarget)}
							placeholder={isWeekRange ? 'End week' : 'End date'}
						/>
					</Box>
				) : null}
			</Box>
			<CustomInputMenu open={isMenuOpened} id="basic-menu" anchorEl={anchorEl} onClose={onClose}>
				<MenuItem onClick={() => onRangeTypeSelect('day')}>By day</MenuItem>
				<MenuItem onClick={() => onRangeTypeSelect('week')}>By week</MenuItem>
			</CustomInputMenu>
			{/* Calendar */}
			<DateRangeContext.Provider
				value={{
					cbSetDateRange: handleSetDateRange,
					usrSelection: dateRange,
					showWk: isWeekRange,
					showWalCal: true,
					isCalMember: true,
					singleWkSelEnable: false,
					bussName: isWeekRange ? 'Week' : 'Date',
					updateDateFor,
					isMTSCalendar: true
				}}>
				<ShowCalender
					open={Boolean(calendarAnchorEl)}
					anchorEl={calendarAnchorEl}
					cbHandleClose={() => setCalendarAnchorEl(null)}
				/>
			</DateRangeContext.Provider>
		</>
	);
};

export default MTSCustomRangeInput;
